<template>
  <div class="icon gold-logo" v-html="GoldLogo"></div>
</template>

<script>
import GoldLogo from './gold-logo.svg'
export default {
  data () {
    return {
      GoldLogo: GoldLogo
    }
  }
}
</script>



// WEBPACK FOOTER //
// uncommon-client/components/svgs/GoldLogo.vue